import {
  ADD_ADDRESS,
  ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_ERROR,
  FETCH_ADDRESSES,
  FETCH_ADDRESSES_SUCCESS,
  FETCH_ADDRESSES_ERROR,
  REMOVE_ADDRESS,
  REMOVE_ADDRESS_SUCCESS,
  REMOVE_ADDRESS_ERROR,
  MODIFY_ADDRESS,
  MODIFY_ADDRESS_SUCCESS,
  MODIFY_ADDRESS_ERROR,
} from '../actionTypes';

const INIT_STATE = {
  addresses: [],
  modifiedAddress: null,
  error: '',
  loading: false,
  modifying: false,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_ADDRESS:
      return { ...state, modifying: true, error: '', modifiedAddress: null };
    case ADD_ADDRESS_SUCCESS: {
      return {
        ...state,
        modifying: false,
        modifiedAddress: action.payload,
        addresses: state.addresses.concat([{ ...action.payload }]),
        error: '',
      };
    }
    case ADD_ADDRESS_ERROR:
      return {
        ...state,
        modifying: false,
        error: action.payload.message,
      };
    case FETCH_ADDRESSES:
      return { ...state, loading: true, error: '' };
    case FETCH_ADDRESSES_SUCCESS: {
      return {
        ...state,
        loading: false,
        addresses: [...action.payload],
        error: '',
      };
    }
    case FETCH_ADDRESSES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case REMOVE_ADDRESS:
      return { ...state, modifying: true, error: '', modifiedAddress: null };
    case REMOVE_ADDRESS_SUCCESS: {
      return {
        ...state,
        modifying: false,
        modifiedAddress: action.payload,
        addresses: state.addresses.filter(
          (address) => address._id !== action.payload._id
        ),
        error: '',
      };
    }
    case REMOVE_ADDRESS_ERROR:
      return {
        ...state,
        modifying: false,
        error: action.payload.message,
      };
    case MODIFY_ADDRESS:
      return { ...state, modifying: true, error: '', modifiedAddress: null };
    case MODIFY_ADDRESS_SUCCESS: {
      const addressList = [...state.addresses];
      const modifyIndex = addressList.findIndex(
        (address) => address._id === action.payload._id
      );
      addressList[modifyIndex] = { ...action.payload };

      return {
        ...state,
        modifying: false,
        modifiedAddress: action.payload,
        addresses: addressList,
        error: '',
      };
    }
    case MODIFY_ADDRESS_ERROR:
      return {
        ...state,
        modifying: false,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};

export default reducer;
